export const selectSuppliers = (state) => state.suppliers.suppliers;

export const selectSuppliersLoading = (state) => state.suppliers.loading;

export const selectSuppliersPag = (state) => state.suppliers.suppliersPag;

export const selectSuppliersLoadingPag = (state) => state.suppliers.loadingPag;